import { Input, Upload } from 'antd';
import { CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import { GET, mrs } from 'utils';

import { FormikProps } from 'formik';
import { useQuery } from 'react-query';
import { api } from 'utils/apiRoutes';
type userProps = {
  userData: any;
  onUpdateData?: (data: object) => void;
  formik?: FormikProps<any>;
};
const PersonalInfo: React.FC<userProps> = ({ userData, formik }) => {
  const departmentData = useQuery('get-derpatment-list', async () => {
    return await GET(api.departmentList);
  });
  const departmentList = departmentData?.data?.data.map((item: object) => ({
    label: item['name'],
    value: item['id'],
  }));

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '10%' }} className="avatar-uploader">
        <Upload
          disabled={true}
          name="avatar"
          listType="picture-circle"
          accept="image/png, image/gif, image/jpeg"
          showUploadList={false}
          // beforeUpload={beforeUpload}
        >
          <img
            style={{
              borderRadius: '50%',
              objectFit: 'cover',
              height: 105,
              width: 105,
            }}
            height={105}
            width={105}
            src={
              userData?.avatar
                ? userData?.avatar['url']
                : userData?.title === 'male'
                ? '/assets/Businessman.png'
                : '/assets/Businesswoman.png'
            }
            alt="avatar"
          />
        </Upload>
      </div>
      <div style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex',
            gap: '32px',
          }}
        >
          <div style={{ width: '33%' }}>
            <CustomDropdown
              defaultKey={formik?.values?.title}
              title="Title"
              value={formik?.values?.title}
              fontSize={12}
              height="50px"
              options={mrs}
              defaultBorder="6px"
              width="100%"
              onSelect={(v: string) => {
                if (v) {
                  formik.setFieldValue('title', v);
                }
              }}
            />
          </div>
          <CustomInput
            value={formik.values?.last_name}
            title={'Last name'}
            height="50px"
            required={userData?.role !== 'admin'}
            maxLength={50}
            name="last_name"
            errors={formik.errors}
            width={'50%'}
            onChange={formik.handleChange}
            fontSize={12}
          />
          <CustomInput
            value={formik.values?.first_name}
            title={'First name'}
            required={userData?.role !== 'admin'}
            maxLength={50}
            height="50px"
            name="first_name"
            errors={formik.errors}
            width={'50%'}
            fontSize={12}
            onChange={formik.handleChange}
          />
        </div>
        <div
          style={{
            display: 'flex',
            gap: '32px',
            marginTop: '30px',
          }}
        >
          <CustomInput
            disabled={formik?.values?.job_number}
            onChange={formik?.handleChange}
            value={formik?.values?.job_number}
            name="job_number"
            height="50px"
            title={'ID Number'}
            errors={formik.errors}
            fontSize={12}
            required={userData?.role !== 'admin'}
            width={'25%'}
          />
          <CustomInput
            value={formik?.values?.job_title}
            title={'Job Title'}
            required={userData?.role !== 'admin'}
            name="job_title"
            height="50px"
            maxLength={40}
            errors={formik.errors}
            fontSize={12}
            width={'37.5%'}
            onChange={formik?.handleChange}
          />
          <CustomInput
            value={formik?.values?.email}
            name="email"
            fontSize={12}
            title={'Email address'}
            disabled
            height="50px"
            required={userData?.role !== 'admin'}
            width={'37.5%'}
            // onChange={(e) => {
            //   onUpdateData?.({ email: e.target.value });
            //   setState((pre) => ({
            //     ...pre,
            //     data: Object.assign(data, { email: e.target.value }),
            //   }));
            // }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            gap: '32px',
            width: '100%',
            marginTop: '32px',
          }}
        >
          {/* <div
            style={{
              width: '49%',
            }}
          >
            <CustomDropdown
              defaultKey={userData?.department__name}
              onSelect={(data: string) => {}}
              width="100%"
              title="Department"
              options={departmentListData}
            />
          </div> */}
          <div
            style={{
              width: '37%',
            }}
          >
            <CustomDropdown
              disabled
              value={formik?.values?.department_id}
              fontSize={12}
              showIconWhenDisabled
              height="50px"
              defaultBorder="6px"
              title={'Department'}
              defaultKey={formik?.values?.department_id}
              options={departmentList}
              required={userData?.role !== 'admin'}
            />
          </div>

          <div
            style={{
              overflow: 'hidden',
              width: '30%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {formik?.values?.managers?.length > 0 && (
              <div>
                <span
                  style={{
                    lineHeight: '12px',
                    display: 'block',
                  }}
                >
                  <span
                    style={{
                      color: '#898989',
                      fontSize: '10px',
                      fontWeight: 400,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {'Supervisor'}
                  </span>{' '}
                </span>
                <Input
                  autoComplete={'off'}
                  value={
                    formik?.values?.managers?.length > 0 &&
                    formik?.values?.managers[0]?.first_name +
                      ' ' +
                      formik?.values?.managers[0]?.last_name
                  }
                  bordered={false}
                  style={{
                    padding: 0,
                    borderRadius: '0px',
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                    fontSize: 12,
                  }}
                  size={'large'}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
